<template>
  <div id="AlertConfirmAction" class="alert-modal">
    <div v-if="!loading" class="alert-dialog">
      <div class="alert-content">
        <slot name="title"></slot>
        <slot name="text"></slot>
        <button @click="clickCancel" class="btn btn-secundario py-2">{{cancelText}}</button>
        <button @click="clickConfirm" class="btn btn-primario py-2">{{confirmText}}</button>
      </div>
    </div>
    <div v-else>
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      loading: false
    }
  },
  props: {
    confirmText: {
      type: String,
      default: "Ok",
      require: false
    },
    cancelText: {
      type: String,
      default: "Cancelar",
      require: false
    }
  },
  methods: {
    clickConfirm() {
      this.loading = true;
      this.emitConfirm()
    },
    clickCancel() {
      this.$emit("cancelAction");
    },
    async emitConfirm(){
      await this.$emit("confirmAction");
    }
  }
};
</script>

<style scoped>
.alert-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 1100;
}
.alert-content {
  max-width: 400px;
}
.title-alert {
  font-weight: 700;
  font-size: 1.56rem;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 10px;
}
.text-alert {
  font-family: "Open Sans", sans-serif;
}
.button-alert {
  font-family: "Open Sans", sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/AlertConfirmAction.vue